module.exports = __webpack_public_path__ + "img/40_38_058_190.b1f7d4cb.jpg";